var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showBack
      ? _c(
          "div",
          { staticClass: "robot-header fx" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  icon: "el-icon-arrow-left",
                  type: "text",
                  size: "mini",
                },
                on: {
                  click: function ($event) {
                    return _vm.dispatch("robot", "activeIndexChange", 0)
                  },
                },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.subscribeInfo.length,
            expression: "!subscribeInfo.length",
          },
        ],
        staticClass: "xtNoData",
      },
      [
        _c("img", { attrs: { src: require("@/assets/subscribe/empty.png") } }),
        _c("p", [_vm._v("暂无消息")]),
      ]
    ),
    _c(
      "ul",
      { staticClass: "someCompany" },
      _vm._l(_vm.subscribeInfo, function (item) {
        return _c("li", { key: item.id }, [
          _c(
            "p",
            { staticClass: "companyName", attrs: { title: item.content } },
            [_vm._v(_vm._s(item.content))]
          ),
          _c("p", { staticClass: "tips" }, [_vm._v(_vm._s(item.pushTime))]),
        ])
      }),
      0
    ),
    _c(
      "div",
      { class: ["btns", { btnsHidden: !_vm.subscribeInfo.length }] },
      [
        _c(
          "el-button",
          {
            staticStyle: { "margin-left": "20px" },
            attrs: { type: "dialog-confirm", w100: "" },
            on: { click: _vm.toPage },
          },
          [_vm._v("查看订阅")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }